import { UserProduct } from './product.types';

export interface UserProject {
	id: string;
	name: string;
	sourceId: string;
	hubRegion: string;
	teamName: string;
	hubName: string;
	hubUrn: string;
	createdOn: string;
	lastModifiedOn: string;
	accessLevel: string;
	status: string;
	userProducts: UserProduct[];
	roles: string[];
}
